import './index.scss'

$("header .nav li").hover(function(){
    $("header .nav li .navchild").stop().slideUp()
    $(".header-bg").stop().slideDown()
    $(this).find(".navchild").stop().slideDown()
}
,function(){
    $(".header-bg").hide()
    $(this).find(".navchild").hide()
})
$(".header-bg").mouseleave(function(){
    $(".header-bg").stop().slideUp()
    $("header .nav li .navchild").stop().slideUp()
})

$("header .nav li").eq(0).hover(function(){
    $(".header-bg").stop().slideUp()
})

$(".hamburger").click(function(){
    $(this).toggleClass("active");
    $(".mob-nav").toggleClass("active");
})
$(".mob-nav .nLi").click(function() {
    $(this).find(".sub").slideToggle();
    $(this).toggleClass("active");
})

$(function () {
    $(window).scroll(function () {
        // 可是窗口滚动条发生滚动的时候 垂直方向滚动到多少距离的时候 让头部导航条设置上一个固定定位的样式
        if ($(window).scrollTop() >= ($("header").height())) {
            // alert($("#slideBox").height());
            $("header").addClass("head1");
        } else {
            $("header").removeClass("head1");
        }
    })
})
//滚动定位
$(document).ready(function() {
    if (location.hash) {
        setTimeout(function() {
            var targetOffset = $(location.hash).offset().top;
        console.log(targetOffset)
            $('html, body').animate({
                scrollTop: targetOffset - 98
            }, 500);
        }, 10);
    }
});
$(window).scroll(function () {
    // 可是窗口滚动条发生滚动的时候 垂直方向滚动到多少距离的时候 让头部导航条设置上一个固定定位的样式
    if ($(window).scrollTop() >= ($("header").height())) {
        $("header").addClass("head1");
    } else {
        $("header").removeClass("head1");
    }
})